import script from "./TitleHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleHeader.vue?vue&type=script&setup=true&lang=js"

import "./TitleHeader.vue?vue&type=style&index=0&id=5eb18e38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb18e38"]])

export default __exports__